import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadUserTypes, loadUserTypesFailure, loadUserTypesSuccess } from './userTypes.actions';
import { ApiResponse } from '@shared';
import { ToastrService } from 'ngx-toastr';
import { UserTypeService } from '@services';
import { IPaginationParams } from '../../interfaces/IPaginationParamas';
import { IUserType } from '@interfaces';

@Injectable()
export class UserTypesEffect {
  constructor(
    private actions$: Actions,
    private _toast: ToastrService,
    private userTypeService: UserTypeService,
  ) {}
  loadUserTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserTypes),
      mergeMap(() =>
        this.userTypeService.getAllUserTypes({ pageNum: 1, pageLimit: 'all' } as IPaginationParams).pipe(
          map((response: ApiResponse) => {
            if (response.status) {
              const userTypes = [...response.data]
                .sort((a: IUserType, b: IUserType) => (a.sequence ?? 0) - (b.sequence ?? 0))
                .map((item: IUserType) => ({
                  id: item._id,
                  name: item.name.hebrew,
                  hebrewName: item.name.hebrew,
                  arabicName: item.name.arabic,
                  key: item.key,
                }));
              return loadUserTypesSuccess({ userTypes });
            } else {
              this._toast.error(response.message);
              return loadUserTypesFailure({ error: '[UserTypes] Load UserTypes Failure' });
            }
          }),
          catchError((error) => {
            this._toast.error(error || error.message);
            return of(loadUserTypesFailure({ error: '[UserTypes] Load UserTypes Failure' }));
          }),
        ),
      ),
    ),
  );
}
